import React from "react";

import { Rating } from "@/components";

import { emDash } from "./constants";
import { Inline, Text } from "@origin-digital/ods-core";

export const RatingRenderer = (
  item: number | null | undefined,
  dataId: string,
  options: {
    [breakpoint: string]: boolean;
  }
) => {
  return (
    <>
      {!item || typeof item !== "number" || isNaN(item) ? (
        <>{emDash}</>
      ) : (
        <Inline space="small">
          <Text variant="body-small">{item}</Text>
          <Rating
            dataId={dataId}
            value={item}
            readOnly
            precision={0.1}
            size={options[Object.keys(options)[0]] ? "medium" : "small"}
            style={{
              flexWrap: "wrap",
              width: "fit-content",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto",
              fontSize: "1rem",
            }}
          />
        </Inline>
      )}
    </>
  );
};
